import immutableTransform from "redux-persist-transform-immutable";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native

import createFilter, {
  createBlacklistFilter
} from "@actra-development-oss/redux-persist-transform-filter-immutable";

import autoMergeImmutable from "./automergeLevel2-immutable";

const saveSubsetFilter = createFilter("datatools", [
  ["download", "sample"],
  ["download", "startDateFilter"],
  ["download", "endDateFilter"],
  ["download", "chipChips"],
  ["download", "showAdvancedSearch"],
  ["download", "advancedFilters"],
  ["download", "colsSelected"],
  ["download", "rawHeaders"]
]);

const saveSubsetBlacklistFilter = createBlacklistFilter("datatools", [
  "status",
  "upload"
]);

const persistConfig = {
  key: "root",
  storage,
  debug: false,
  stateReconciler: autoMergeImmutable,
  whitelist: ["datatools"],
  throttle: 1000,
  transforms: [
    saveSubsetFilter,
    saveSubsetBlacklistFilter,
    immutableTransform()
  ]
};

export default persistConfig;
